import { Radio as BlueprintRadio } from "@blueprintjs/core";
import { RadioProps } from "./types";
import { styles } from "./styles";

/**
 * `Radio` renders a single radio button.
 * It is typically used as a child of a `RadioGroup` component, but it can also be used standalone.
 */
const Radio: React.FC<RadioProps> = ({
  label,
  name,
  value,
  variant = "default",
  disabled = false,
  onChange,
  checked = false,
  error = false
}) => {
  if (variant === "chip") {
    const ariaLabel =
      typeof label === "string" ? label : `Radio option ${value}`;

    return (
      <label
        css={[
          styles.chipVariant,
          disabled && styles.chipDisabled,
          checked && styles.chipSelected,
          error && styles.chipError
        ]}
      >
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          css={styles.chipInput}
          aria-label={ariaLabel}
        />
        {label}
      </label>
    );
  }

  return (
    <BlueprintRadio
      name={name}
      value={value}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      css={[styles.input, error && styles.error]}
    >
      {label}
    </BlueprintRadio>
  );
};

export default Radio;
export * from "./types";
